module.exports = __webpack_public_path__ + "img/RF-01.f8ecf655.jpg";